import { RefObject } from 'react'
import { Box, Card, styled, SxProps } from '@mui/material'

const StyledCard = styled(Card)`
  /* @noflip */
  text-align: right;
  width: 100%;
  height: 100%;
  //position: relative;
  background-color: black;
  border-radius: unset;

  ${({ theme }) => theme.breakpoints.up('desktop')} {
    position: fixed;
    left: 0;
    right: 0;
    max-width: 100%;
  }

  .MuiPaper-root {
    border-radius: unset;
  }

  z-index: 1;
`

interface Props {
  cardRef: RefObject<HTMLDivElement>
  appbarComponent?: JSX.Element
  children: JSX.Element | JSX.Element[]
  appbarRef?: RefObject<HTMLDivElement>
  onClick?: () => unknown
  sxProps?: SxProps
}

export function MediaCard({
  cardRef,
  appbarRef,
  appbarComponent,
  children,
  onClick,
  sxProps,
}: Props) {
  return (
    <StyledCard ref={cardRef} onClick={onClick} sx={sxProps}>
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          backgroundColor: '#00000080',
          zIndex: 1,
        }}
        ref={appbarRef}
        onClick={e => e.stopPropagation()}
      >
        {appbarComponent}
      </Box>
      {children}
    </StyledCard>
  )
}
